import React from 'react';
import { Typography } from '@material-ui/core';

const PageTitle = ({ title }) => (<div className="ml-4 mt-4">
  <Typography variant="h2">{title}</Typography>
</div>);

export default PageTitle;
